var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 85,
    viewBox: "0 0 92 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M65.346 81.2187C66.4586 49.7255 43.1046 20.4916 12.2066 14.4655C9.58747 13.9548 8.6987 18.0143 11.332 18.5259C25.671 21.548 38.5029 29.4864 47.6084 40.9681C56.7138 52.4499 61.5201 66.7528 61.1961 81.4032C61.1019 84.079 65.2526 83.8773 65.346 81.2187Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.1032 40.4923C83.1018 32.2343 79.1783 24.5657 73.6522 18.111C68.126 11.6563 61.1535 6.59791 53.3025 3.34792C50.8536 2.32953 48.9387 6.01767 51.4164 7.05046C58.7676 10.0554 65.2976 14.7678 70.466 20.7975C75.6344 26.8273 79.2927 34.0011 81.138 41.7254C81.7747 44.3374 85.7327 43.0827 85.1032 40.4923Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurls);
export default __webpack_public_path__ + "static/media/curls.af36e5ffe2cd668eeee64cd16bbb8f2b.svg";
export { ForwardRef as ReactComponent };